export default "__VITE_ASSET__DF$X2KFH__"